import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto"
};
const _hoisted_2 = {
  class: "flex min-h-full items-center justify-center p-4 sm:p-8 text-center"
};
const _hoisted_3 = {
  class: "max-h-[70vh] overflow-y-auto overflow-x-hidden"
};
const _hoisted_4 = {
  class: "font-bold"
};
const _hoisted_5 = {
  class: "text-xl my-4 font-bold bold"
};
const _hoisted_6 = {
  class: "space-y-4"
};
const _hoisted_7 = {
  class: "text-lg font-medium text-slate-800 dark:text-black",
  style: {
    "line-height": "1.25rem"
  }
};
const _hoisted_8 = {
  class: "mt-2 leading-relaxed text-slate-800 dark:text-black"
};
const _hoisted_9 = {
  class: "text-xl my-4 font-bold bold"
};
const _hoisted_10 = {
  class: "space-y-4"
};
const _hoisted_11 = {
  class: "text-lg font-medium text-slate-800 dark:text-black",
  style: {
    "line-height": "1.25rem"
  }
};
const _hoisted_12 = {
  class: "mt-4 sm:mt-8 flex justify-end space-x-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IdentificationIcon = _resolveComponent("IdentificationIcon");
  const _component_TransitionChild = _resolveComponent("TransitionChild");
  const _component_DialogTitle = _resolveComponent("DialogTitle");
  const _component_DialogPanel = _resolveComponent("DialogPanel");
  const _component_Dialog = _resolveComponent("Dialog");
  const _component_TransitionRoot = _resolveComponent("TransitionRoot");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openDialog && $options.openDialog(...args)),
    class: "btn flex items-center justify-center px-3 py-2 rounded-full text-white hover:bg-white hover:border-slate-300 hover:shadow-lg hover:text-indigo-500 dark:hover:bg-white dark:hover:text-white transition-colors duration-200"
  }, [_createVNode(_component_IdentificationIcon, {
    class: "hidden w-5 h-5 mr-1 xl:mr-2 sm:block"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.aboutUs")), 1)]), _createVNode(_component_TransitionRoot, {
    appear: "",
    show: $data.isDialogOpen,
    as: "template"
  }, {
    default: _withCtx(() => [_createVNode(_component_Dialog, {
      as: "div",
      class: "relative z-10",
      open: $data.isDialogOpen,
      onClose: $options.closeDialog
    }, {
      default: _withCtx(() => [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0",
        "enter-to": "opacity-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100",
        "leave-to": "opacity-0"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "fixed inset-0 bg-black/25"
        }, null, -1)])),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0 scale-95",
        "enter-to": "opacity-100 scale-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100 scale-100",
        "leave-to": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [_createVNode(_component_DialogPanel, {
          style: {
            "background": "#F6F9FB"
          },
          class: "w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-white p-3 sm:p-6 text-left align-middle shadow-lg dark:shadow-gray-900 transition-all"
        }, {
          default: _withCtx(() => [_createVNode(_component_DialogTitle, {
            as: "h3",
            class: "text-2xl font-bold leading-6 text-slate-800 dark:text-black mb-3 sm:mb-6"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("HeaderView.HeaderAbout.researchTeam")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, [_createTextVNode(_toDisplayString(_ctx.$t("HeaderView.HeaderAbout.first_p1")), 1), _cache[4] || (_cache[4] = _createElementVNode("span", {
            style: {
              "font-style": "italic"
            }
          }, [_createElementVNode("a", {
            target: "_blank",
            style: {
              "text-decoration": "underline"
            },
            href: "https://arxiv.org/abs/2411.06159"
          }, " Mixture of Knowledge Minigraph Agents for Literature Review Generation")], -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.first_p2")) + " ", 1), _createElementVNode("button", {
            class: "btn2 cursor-pointer px-3 rounded-full",
            style: {},
            onClick: _cache[1] || (_cache[1] = (...args) => $options.feedbackForm && $options.feedbackForm(...args))
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.user_feedback")), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.first_p3")) + " ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.note1")), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.note2")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.note3")), 1)]), _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.research")), 1), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.authors, (author, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "flex",
              key: index
            }, [_createElementVNode("div", {
              style: _normalizeStyle([{
                backgroundImage: `url(${author.avatar})`
              }, {
                "width": "7rem",
                "height": "7rem",
                "flex-shrink": "0",
                "background-color": "transparent",
                "background-size": "cover"
              }]),
              class: "mr-3 rounded-full"
            }, null, 4), _createElementVNode("div", null, [_createElementVNode("h5", _hoisted_7, _toDisplayString(author.name), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(author.description), 1)])]);
          }), 128))]), _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.develop")), 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.developers, (author, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "flex",
              key: index
            }, [_createElementVNode("div", {
              style: _normalizeStyle([{
                backgroundImage: `url(${author.avatar})`
              }, {
                "width": "7rem",
                "height": "7rem",
                "flex-shrink": "0",
                "background-color": "transparent",
                "background-size": "cover"
              }]),
              class: "mr-3 rounded-full"
            }, null, 4), _createElementVNode("div", null, [_createElementVNode("h5", _hoisted_11, _toDisplayString(author.name), 1), _cache[5] || (_cache[5] = _createElementVNode("p", {
              class: "mt-2 leading-relaxed text-slate-800 dark:text-black"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(author.description), 1)])]);
          }), 128))])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
            class: "btn2 inline-flex justify-center rounded-full px-4 py-2 shadow-lg hover:shadow-lg bg-indigo-500 dark:bg-indigo-600 text-black hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors duration-200",
            onClick: _cache[2] || (_cache[2] = (...args) => $options.closeDialog && $options.closeDialog(...args))
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.close")), 1)])]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["open", "onClose"])]),
    _: 1
  }, 8, ["show"])], 64);
}